import { getResolvedScoreboardIanaTimeZone } from './scoreboardIntlTimeZone.helper';

/**
 * YYYY-MM-DD for an ISO instant in the given IANA zone via Intl (DST-safe).
 * Optional timeZone defaults to getResolvedScoreboardIanaTimeZone() so API + list stay aligned.
 */
export function localCalendarDateKeyFromIso(isoDate: string, timeZone?: string): string | null {
  const d = new Date(isoDate);
  if (Number.isNaN(d.getTime())) return null;

  const resolvedZone = timeZone || getResolvedScoreboardIanaTimeZone();

  try {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: resolvedZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });

    const parts = formatter.formatToParts(d);
    const y = parts.find((p) => p.type === 'year')?.value;
    const m = parts.find((p) => p.type === 'month')?.value;
    const day = parts.find((p) => p.type === 'day')?.value;

    if (y && m && day) {
      return `${y}-${m}-${day}`;
    }
  } catch (error) {
    console.warn(`Failed to format date for timezone ${resolvedZone}`, error);
  }

  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
